import React from 'react';
import { paymentType as PaymentTypes, paymentMethod as PaymentMethods } from '@ourbranch/lookups';
import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useFormikContext } from 'formik';

import { useStore } from 'core/store';
import { FormField } from 'core/components/form';
import { LabelTooltip } from 'core/components/label-tooltip';
import usePaymentFrequencyOptions from '../hooks/use-payment-frequency-options';
import { filterFrequencyOptionsForMethod, getPaymentMethodOptions } from '../helpers';

const RenewalPaymentOptions = () => {
  const {
    account: {
      policies: { policy: policyStore }
    }
  } = useStore();
  const { policy } = policyStore;
  const { values, setFieldValue } = useFormikContext();

  const isMortgage = values.renewalPaymentMethod === PaymentMethods.Escrow;
  const isPayToOther = values.paymentMethod === PaymentMethods.BillToOther;

  const { frequencyOptions, isDisabled, tooltip } = usePaymentFrequencyOptions({
    paymentType: policy.renewalPaymentType,
    policyType: policy.policyType,
    state: policy.state,
    allowMonthlyPayments: policy.renewalVariables?.allowMonthlyPayments
  });

  const filteredFrequencyOptions = filterFrequencyOptionsForMethod({
    options: frequencyOptions,
    paymentMethod: values.paymentMethod,
    mortgageMethod: values.renewalPaymentMethod,
    currentPaymentType: values.renewalPaymentType,
    // The Direct rule follows the current-term method, so the saved renewal plan pairs that method with
    // the stored renewal frequency (#37291).
    savedPlan: { method: policy.paymentMethod, type: policy.renewalPaymentType ?? policy.paymentType },
    policyType: policy.policyType
  });

  return (
    <>
      <FormField
        name="renewalPaymentMethod"
        type="select"
        label="Renewal Payment Method"
        mode="dark"
        xs={6}
        options={getPaymentMethodOptions(policy.policyType)}
        permissions={{ isLicensedAction: false }}
        fast={false}
        onChange={(val) => {
          if (val === PaymentMethods.Escrow) {
            setFieldValue('renewalPaymentType', PaymentTypes.Escrow);
          } else {
            // ach or credit card
            setFieldValue(
              'renewalPaymentType',
              values.renewalPaymentType === PaymentTypes.Escrow ? PaymentTypes.OneTime : values.renewalPaymentType
            );
          }
        }}
      />
      {tooltip && (
        <Grid item xs={6}>
          <LabelTooltip
            label="Renewal Payment Frequency"
            tooltip={{
              label: 'More Info',
              onHoverText: tooltip
            }}
          >
            <FormField
              name="renewalPaymentType"
              type="select"
              disabled={isMortgage || isPayToOther || isDisabled}
              options={filteredFrequencyOptions}
              mode="dark"
              sions={{ isLicensedAction: false }}
              fast={false}
            />
          </LabelTooltip>
        </Grid>
      )}
      {!tooltip && (
        <FormField
          name="renewalPaymentType"
          type="select"
          label="Renewal Payment Frequency"
          mode="dark"
          xs={6}
          disabled={isMortgage || isPayToOther || isDisabled}
          options={filteredFrequencyOptions}
          permissions={{ isLicensedAction: false }}
          fast={false}
        />
      )}
    </>
  );
};

export default observer(RenewalPaymentOptions);
